<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="text-center" style="padding: 50px 0">
          <img alt="IzOnay" src="../assets/logo.png" />
        </div>

        <div class="text-center">
          <div class="form-control text-center" style="height:auto;">
            <h1>
              <code>{{ loginData.AccountCode }}</code>
            </h1>
            <div>{{ loginData.Email }}</div>
          </div>
          <div class="mb-3">
            <a class="btn btn-link" href="#" @click.prevent="$router.push('/')"
              >Hesap değiştir</a
            >
          </div>
        </div>

        <form @submit.prevent="login()">
          <fieldset :disabled="loading">
            <div class="mb-3">
              <label for="password" class="form-label">Parola</label>
              <input
                type="password"
                v-model="loginData.Password"
                class="form-control form-control-lg"
                id="password"
                required
              />
            </div>

            <div class="mb-3" v-show="captcha && captcha.isCaptchaRequired">
              <label>Doğrulama Kodu</label>
              <div class="input-group input-group-lg">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text captcha"
                    title="Doğrulama kodunu yenilemek için tıklayın"
                    ref="captcha"
                    @click="checkCaptchaRequirement()"
                  ></span>
                </div>
                <input
                  v-model="loginData.Captcha"
                  type="text"
                  placeholder="Yandaki doğrulama kodunu giriniz"
                  class="form-control"
                  :required="captcha && captcha.isCaptchaRequired"
                />
              </div>
            </div>

            <div class="d-grid gap-2">
              <input
                type="submit"
                class="btn btn-primary btn-lg"
                value="Giriş"
              />
            </div>
            <div class="d-grid gap-2">
              <button
                type="button"
                class="btn btn-success btn-lg mt-2"
                @click="getAgreement"
              >Mobil İmza ile Giriş</button>
            </div>
          </fieldset>
        </form>
        <div v-show="isExternalLoginAvailable" class="row m-5" id="external-logins">
            <div class="col-md-12">   
                <div class="text-center">             
                    <h6>Veya şununla oturum açın:</h6>
                </div>
            </div>
            <div v-if="isADFSLoginEnabled" class="col">
                <LoginWithADFS></LoginWithADFS>
            </div>
            <div v-else class="col">
                <LoginWithMicrosoft></LoginWithMicrosoft>
            </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div v-if="errorMessage" style="margin-top: 20px">
          <div class="alert alert-danger" v-text="errorMessage"></div>
        </div>
      </div>
    </div>
    <Transition>
      <div v-if="fingerprint" class="modal fade show" style="display: block" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Mobil İmza ile Giriş</h5>
              <button type="button" class="btn btn-sm btn-outline-secondary" @click="fingerprint = null" aria-label="Kapat">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>'İzOnay uygulamasında <code>{{ this.loginData.AccountCode }} </code> hesap kodu ile oturum açmayı kabul ediyorum.'</p>
              <p><b>Email : </b>{{ fingerprint.Email }}</p>
              <p><b>GSM : </b>{{ fingerprint.GSM }}</p>
              <p><b>Parmak İzi : </b>  <code>{{ fingerprint.Fingerprint }}</code></p>
              <div v-if="timerShow"  style="display: flex; flex-direction: column; gap: 20px; justify-content: center; align-items: center;">
                <div v-for="example,e in examples" :key="e">
                  <circular-count-down-timer ref="countdown" :circles="example.circles" :interval="example.interval"
                        :main-circle-id="example.mainCircleId || '1'" :size="example.size"
                        :container-classes="example.containerClasses"
                        :circle-classes="example.circleClasses"
                        :stop-conditions="example.stopConditions"
                        :trigger-update="example.triggerUpdate" :stroke-width="example.strokeWidth"
                        :stroke-color="example.strokeColor"
                        :underneath-stroke-color="example.underneathStrokeColor"
                        :fill-color="example.fillColor" :value-font-size="example.valueFontSize"
                        />
                </div>
              </div>
              <p v-if="timerShow" style="display: flex; align-items: center; justify-content: center; gap: 10px; color: rgb(14, 145, 226);"><Spinner></Spinner> Mobil imza onayı bekleniyor...</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="fingerprint = null">Kapat</button>
              <button type="button" class="btn btn-success" :disabled="waitingMobile" @click="mobileSign">Mobil İmzala</button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>
<script>
import axios from "axios";
import Spinner from '../components/Spinner.vue'
import CircularCountDownTimer from '../components/CircularCountDownTimer.vue'
import LoginWithMicrosoft from '@/components/Login/LoginWithMicrosoft.vue'
import LoginWithADFS from '@/components/Login/LoginWithADFS.vue'

export default {
  mounted() {
    if (this.loginData.AccountCode && this.loginData.Email) {
      this.checkCaptchaRequirement();
    }
  },
  computed: {
        isADFSLoginEnabled(){
            return window.settings.authentication?.adfs?.enabled;
        },
        isAzureLoginEnabled(){
            return window.settings.authentication?.adfs?.enableAzure;
        },
        isExternalLoginAvailable()
        {
            if(!this.isOnPrem || this.isADFSLoginEnabled  || this.isAzureLoginEnabled)
                return true;
            
            return false;
        }
  },
  components: {
    Spinner,
    CircularCountDownTimer,
    LoginWithMicrosoft,
    LoginWithADFS
  },
  data() {
    return {
      loading: false,
      loginData: {},
      step: 0,
      captcha: null,
      errorMessage: null,
      fingerprint: null,
      timerShow: false,
      waitingMobile: false,
      examples: [
				{
					title: 'Decremental counter',
          stopConditions: { '1': 0},
					circles: [
						{
							id: '1',
							steps: 60,
							size: 60,
							value: 60,
							stepLength: -1,
              strokeWidth: 5,
							strokeColor: 'green',
						}
					]
				},
			]
    };
  },
  beforeMount() {
    var hash = location.hash.replace("#", "");
    var accountUser = hash.split("&");

    var code = accountUser[0];
    var email = accountUser[1];

    if (!accountUser) {
      this.$router.push("/");
    } else {
      if (!code || !email) this.$router.push("/");
      else {
        this.loginData.AccountCode = code;
        this.loginData.Email = email;
      }
    }
  },
  methods: {
    restartCountDown(val){
        try {
            this.$refs.countdown[0].restartTimer(val);
        }catch(e){
            console.log(e);
        }
    },
    mobileSign() {
        this.timerShow = true;
        this.waitingMobile = true;
        axios.post('token/SignMobile', {
            AccountCode: this.loginData.AccountCode,
            Email: this.loginData.Email,
            GSM: "5547789703",
            Agreement: this.fingerprint.Agreement,
            FingerPrintTempFileId: this.fingerprint.FingerPrintTempFileId
        })
            .then(x => {
                console.log('MobileSign login result:', x);
                if (x.data.Success) {
                    window.localStorage.setItem('user', JSON.stringify(x.data.Data));
                    axios.defaults.headers.common['token'] = x.data.Data.Key;
                    this.$root.$data.login = x.data.Data;
                    this.$router.push('/index');
                } else {
                    this.restartCountDown(1);
                    this.waitingMobile = false;
                    this.loading = false;
                    this.fingerprint = null;
                    this.loginData.Email = null;
                    this.loginData.GSM = null;
                    this.processingMessage = null;
                    this.timerShow = false;
                    this.showbutton = true
                    this.waitingMobile = false;
                }
            })
            .catch(x => {
                console.log('Mobile Oturum aç cevabı: ', x);
                this.waitingMobile = false;
                this.loading = false;
                this.loginData.Email = null;
                this.loginData.GSM = null;
                this.restartCountDown(1);
                window.processErrorResponse(x, this);
            })

    },
    getAgreement() {
        this.loading = true;
        this.fingerprint = null;
        this.errorMessage = null;
        this.processingMessage = 'Parmakizi Hesaplanıyor..';
        return axios.post('token/Calculatefingerprint', {
            AccountCode: this.loginData.AccountCode,
            Email: this.loginData.Email,
            GSM: "5547789703"
        })
            .then(x => {
                this.loginData.accountCode = x.data.AccountCode;
                this.fingerprint = x.data;
                this.$forceUpdate();
            })
            .catch(x => {
                window.processErrorResponse(x, this);
                console.log('Oturum taahhütnamesi oluşturulamadı: ', x);
            }).then(() => {
                this.loading = false;
                this.processingMessage = null;
            });
    },
    checkCaptchaRequirement() {
      this.step = 1;
      this.loading = true;
      axios
        .post('/token/isCaptchaRequired', { Email: this.loginData.Email})
        .then(x => {
          this.captcha = x.data;
          this.loginData.Identifier = x.data?.identifier;
          this.$refs.captcha.style = `background-image: url('data:image/jpg;base64,${x.data.image}')`;
          this.loginData.Captcha = null;
          this.loading = false;
        })
        .catch(x => {
          this.step = 0;
          window.processErrorResponse(x, this);
          this.$refs.captcha.style =
            "background-color:red; background-image:none;";
          this.loginData.Identifier = null;
          this.loginData.Captcha = null;
          this.loading = false;
        });
    },
    async loginWithEmail() {
      const { data } = await axios.post("/token/post", {
        accountCode: this.loginData.AccountCode,
        email: this.loginData.Email,
        password: this.loginData.Password,
        identifier: this.loginData.Identifier,
        captcha: this.loginData.Captcha,
        source: "Mobile"
      });
      return data;
    },
    login() {
      this.errorMessage = null;
      this.loading = true;

      this.loginWithEmail()
        .then(x => {
          this.errorMessage = null;
          console.log("Gelen sonuç:", x);
          if (x.Success) {
            if (x.Data.SessionId) {
              this.$router.push({
                name: "/mfa",
                params: { loginData: x.Data }
              });
            } else {
              window.localStorage.setItem("user", JSON.stringify(x.Data));
              axios.defaults.headers.common["token"] = x.Data.Key;
              this.$root.$data.login = x.Data;

              this.$store.commit("setUser", x.Data.User);
              this.$router.push("/index");
              console.log(
                "Token geldi: ",
                axios.defaults.headers.common["token"]
              );
            }
          } else {
            this.errorMessage = x.ErrorMessages;
            this.checkCaptchaRequirement();
          }
          console.log("Token geldi: ", axios.defaults.headers.common["token"]);
        })
        .catch(e => {
          console.log("Error:", e);
          if (e.response === undefined) {
            this.errorMessage =
              "Erişim sağlanamadı. Lütfen internet bağlantınızı kontrol edin.";
          } else if (e.response.status == 400) {
            this.errorMessage =
              window.getModelStateString(e.response.data.ModelState) ||
              e.response.data.Message;
          } else {
            this.errorMessage =
              "Beklenmeyen bir hata oluştu. Lütfen bir süre sonra tekrar deneyin";
          }
          this.checkCaptchaRequirement();
        });
    }
  }
};
</script>
<style scoped>
.captcha {
  width: 100px;
  height: 50px;
  background-repeat: no-repeat;
  background-position: center center;
  cursor: pointer;
}

.modal{
  background-color: rgba(0,0,0,0.8) !important;
}
.modal-content{
  top: 25vh !important;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
